import { render, staticRenderFns } from "./InboxInfo.vue?vue&type=template&id=3310260c&"
import script from "./InboxInfo.vue?vue&type=script&lang=js&"
export * from "./InboxInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports